import React from 'react';
import Navbar from '../../components/common/Header/Navbar';
import bannerimg from '../../assets/Recharge_api_images/domain_banner.jpg';
import missionvissonimg from '../../assets/Recharge_api_images/domain_api_img.png';
import "../../styles/recharge_api.css";
import increasedRevenueIcon from '../../assets/Recharge_api_images/increase1.png';
import scalabilityIcon from '../../assets/Recharge_api_images/relationships2.png';
import customerRetentionIcon from '../../assets/Recharge_api_images/retension.png';
import fintechIcon from '../../assets/Recharge_api_images/fintech.png';
import retailIcon from '../../assets/Recharge_api_images/retail.png';
import ecommerceIcon from '../../assets/Recharge_api_images/Ecommerce.png';
import benefitBanner from '../../assets/Recharge_api_images/benefit_banner.png';

import securityMeasuresImage from '../../assets/Recharge_api_images/security1.png';
import securitysecurityMeasuresImage from '../../assets/Recharge_api_images/security2.png';


import integrationProcessImage from '../../assets/Recharge_api_images/integration_background.png';

const domain_Api = () => {

  const FeatureBox = ({ title, description, isPrimary = false , className = '' }) => (
    <div className={`feature-box ${isPrimary ? 'feature-box-primary' : 'feature-box-secondary'} ${className}`}>
      <h4 className="feature-title font-lato text-[20px] font-bold">{title}</h4>
      <p className="feature-description text-ellipsis  font-lato text-[17px] font-normal leading-[26px]">{description}</p>
    </div>
  );

  // ✅ you used values in CoreValues & HowItWorks but didn’t define it
  const values = [
    { title: "Integrity", desc: "We believe in transparency and trust." },
    { title: "Innovation", desc: "We build solutions for tomorrow." },
  ];

const BenefitCard = ({ icon, title, description, isBlue = false }) => (
  <div
    className={`benefit-card ${isBlue ? 'benefit-card-blue' : 'benefit-card-white'} group p-6 rounded-xl shadow-lg transition-colors duration-300 cursor-pointer`}
  >
    <div className="card-icon-container mb-4">
      {icon ? (
        <img src={icon} alt={title} className="card-icon w-12 h-12" />
      ) : (
        <div className="card-icon-placeholder w-12 h-12"></div>
      )}
    </div>
    <h3 className="card-title text-gray-900 text-xl font-semibold mb-2 transition-colors duration-300">
      {title}
    </h3>
          <p 
        className="card-description text-[#6E6E6E] transition-colors duration-300 font-lato text-[17px] font-normal leading-[26px]"
      >
        {description}
      </p>
  </div>
);



   const renderImageCard = (imageSrc, altText, title, description, linkText) => (
        <div className="image-card-container">
            {/* The main background image holder (dark curved shape) */}
            <div className="image-card-background">
                {imageSrc ? (
                    <img src={imageSrc} alt={altText} className="content-image" />
                ) : (
                    <div className="image-placeholder"></div>
                )}
            </div>
            
            {/* The nested white card with text overlay */}
            <div className="image-text-card">
                <h3>{title}</h3>
                <p>{description}</p>
                <a href="#" className="see-more-link">{linkText} →</a>
            </div>
        </div>
    );



  return (
    <>
      {/* Navbar */}
      {/* <Navbar /> */}

      {/* Banner Section */}

            <div className="relative w-full h-[300px] md:h-auto min-h-52">
                <img
                    src={bannerimg}
                    alt="About Banner"
                    className="w-full h-full object-cover" // Added h-full and object-cover to make sure the image fills the container height
                />
                <div className="banner-content absolute inset-0  flex flex-col items-center justify-center px-6 py-12 md:pb-1 xs:pb-1"> {/* Added vertical padding */}
                    <h1 
                        className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal" // Made font size responsive
                    >
                          Domain API 
                    </h1>

                    <p 
                        className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2" // Made font size responsive and added margin top
                    >
                      Powering Digital Presence with Seamless Domain Services
                    </p>
                </div>
            </div>



      {/* Content Section */}
<section className="recharge-api-section">
  <div className="content-container">
    {/* --- LEFT COLUMN: TEXT & FEATURES --- */}
    <div className="text-and-features-column">
      <p className="section-tag">OUR DOMAIN SERVICES </p>
      <h1 className="main-title">
       Simplify Domain Operations <br></br> with Smart APIs 
      </h1>
      <p className="main-description font-lato text-[17px] font-normal leading-[26px]">
API Galaxy’s Domain APIs let you search, register, manage, and verify domains effortlessly. Designed for developers and businesses, our APIs bring automation, accuracy, and speed to your digital ecosystem.      </p>

      {/* --- FEATURES GRID --- */}
      <div className="features-grid">
        {/* ROW 1 */}
        <FeatureBox
          title="Instant Domain Search"
          description="Quickly check the availability of any domain across hundreds of TLDs in real-time using our high-performance Domain Search API."
          className="feature-box-2-of-5"
        />
        <FeatureBox
          title="Bulk Domain Management"
          description="Manage multiple domains simultaneously with APIs for registration, renewal, DNS configuration, and WHOIS updates."
          className="feature-box-2-of-5"
        />

        {/* ROW 2 */}
        <FeatureBox
          title="Domain Compliance & Accuracy"
          description="Ensure ICANN and registrar compliance while maintaining accurate WHOIS and DNS records through automated validation."
          className="feature-box-3-of-5"
        />
        <FeatureBox
          title="AI-Powered Suggestions"
          description="Get intelligent, keyword-based domain recommendations that help your customers find the perfect name for their brand. "
          className="feature-box-3-of-5"
        />
      </div>
      {/* --- END FEATURES GRID --- */}
    </div>

    {/* --- RIGHT COLUMN: IMAGE + LAST FEATURE BOX --- */}
<div className="illustration-column flex flex-col items-start gap-1 ">
  <img
    src={missionvissonimg}
    alt="Identity Verification Illustration"
    className="recharge-illustration max-w-full h-auto"
  />
  <br></br><br></br>
<FeatureBox
  title="Reliable API Integration"
  description={
    <>
      Seamlessly integrate with our secure and scalable Domain APIs,<br />ensuring uninterrupted operations and 99.9% uptime.
    </>
  }
  className="seamless-card-int feature-box-3-of-5 w-max"
/>

</div>

  </div>
</section>

  {/* Our Mission Section */}
  <div>
    <section className="benefits-section relative overflow-hidden">
      <div
        className="absolute top-0 left-0 w-full h-[400px]  z-0"
        style={{
          backgroundImage: `url(${benefitBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      {/* 3. Apply the style object and add an overlay div */}
      <div className="benefits-header-content-bg">
        {/* 4. Overlay div for the dark blue tint effect from the original image */}
        <div className="benefits-header-overlay"></div>
      </div>

      <div className="benefits-header-content">
        <div className="header-text-container">
          <p className="header-tag">Integrate Faster. Operate Smarter. </p>
          <h2 className="header-title">Built for the Digital Domain Galaxy</h2>
        </div>
        <div className="header-description-container">
          <p className="header-description text-justify">
           Our domain APIs are built for speed, scalability, and precision trusted by fintechs, cybersecurity platforms, and web intelligence providers worldwide. 
          </p>
        </div>
      </div>

      <div className="benefits-cards-grid-container">
        <div className="benefits-cards-grid">
          {/* Top Row: Benefits */}
          <BenefitCard 
            icon={increasedRevenueIcon} 
            title="Domain Research" 
            description="Instantly check domain name availability across multiple TLDs in real-time." 
          />
          <BenefitCard 
            icon={scalabilityIcon} 
            title="DNS Management" 
            description="Automate DNS record creation, updates, and configuration directly via API." 
          />
          <BenefitCard 
            icon={customerRetentionIcon} 
            title="Email Verification" 
            description="Verify domain-based email identities to ensure valid and secure communication." 
          />

          {/* Bottom Row: Use Cases */}
          <BenefitCard 
            icon={fintechIcon} 
            title="Domain Registration" 
            description="Register and renew domains automatically with top registrars around the world." 
          />
          <BenefitCard 
            icon={retailIcon} 
            title="Website Configuration" 
            description="Streamline hosting, SSL, and DNS setup for seamless deployment." 
          />
          <BenefitCard 
            icon={ecommerceIcon} 
            title="Domain Availability" 
            description="Get instant status updates and suggestions for similar domain names." 
          />
        </div>
      </div>
    </section>
  </div>

      {/* Core Values & How It Works */}
 
 <section className="relative py-16 px-4 md:px-8 lg:px-16 overflow-hidden" style={{
      backgroundImage: `url(${integrationProcessImage})`,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
    }}>
      <div className="max-w-7xl mx-auto">
        {/* --- Top Section Header and Title --- */}
 <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
    >
    Secure Integration. Limitless Domains. 
  </span>
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12 leading-tight">
          Empower Your Digital Business<br />
           with our Domain APIs
        </h1>

        {/* -------------------------------------- */}
        {/* --- 1. Integration Process Section --- */}
        {/* -------------------------------------- */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
          
          <div className="relative w-full lg:w-1/2 min-h-[300px]"> 
            <div className="w-full h-full absolute top-0 left-0">
              <img 
                src={securityMeasuresImage} 
                alt="Integration Process" 
                className="w-[90%] h-full object-cover rounded-xl shadow-2xl" 
       
              />
            </div>

   
<div 
  className="absolute top-1/4 right-0 bg-[#F9F9F9] rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]
             flex flex-col items-start p-6 flex-1">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
              <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                Easily integrate our Domain APIs into your system using simple REST endpoints and well-documented SDKs. 
              </p>
              <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                SEE MORE <span className="ml-2">→</span>
              </a>
            </div>
          </div>

          {/* Right Side: Checklist */}
          <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
            <ul className="space-y-6">
              {[
                "Sign Up & Get API Keys Access your developer credentials and start integration immediately. ",
                "Connect Domain Services Use a single API to handle domain search, registration, and management. ",
                "Launch Instantly Automate processes and deliver domain services to your customers in minutes. ",
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-[#00AFEF]  font-bold text-lg mr-3 mt-1">✓</span>
                  <p className="text-lg text-gray-700">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ------------------------------------- */}
        {/* --- 2. Security Measures Section --- */}
        {/* ------------------------------------- */}

    <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
                <span 
                  className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
                >
                  Integration & Security
                </span>
                {/* Removed <br></br> */}
                
                {/* Added mt-4 or mb-4 to the list for separation */}
                <ul className="space-y-6 mt-4"> 
                  {[
                    "Data Encryption: Protects customer and registration data from unauthorized access.",
                    "Authentication Layers: Ensures only verified platforms can perform domain actions.",
                    "Real-Time Monitoring: Tracks domain activities and DNS updates 24×7 for uninterrupted service.",
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#00AFEF] font-bold text-lg mr-3 mt-1">✓</span>
                      <p className="text-lg text-gray-700">{item}</p>
                    </li>
                  ))}
                </ul>
            </div>
          <div className="relative w-full lg:w-1/2 min-h-[300px]"> 
            <div className="w-full h-full absolute top-0 left-0">
              <img 
                src={securitysecurityMeasuresImage} 
                alt="Integration Process" 
                className="w-[90%] h-full object-cover rounded-xl shadow-2xl" 
        
              />
            </div>

            <div className="absolute top-1/4 right-0 bg-[#F9F9F9] p-6 rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
              <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                Our enterprise-grade security protects your domains, and API Galaxy delivers exceptional infrastructure dependability.
              </p>
              <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                SEE MORE <span className="ml-2">→</span>
              </a>
            </div>
          </div>

         
        </div>


 
      </div>
    </section>




    </>
  );
};

export default domain_Api;
